module.exports = __webpack_public_path__ + "img/Grupo 1099.003c0309.png";